<template>
  <div :class="setListClass()">
    <!-- '이용중' 아이콘 -->
    <span v-if="isUse" class="tag-using-wrap">
      <span class="tag-using" >이용중</span>
    </span>
    <!-- '이용중' 아이콘 -->

    <p class="ticket-hd">
      <span class="ticket-hd-txt">{{productgroups.productgroup_name}}
        <div class="question-popup-wrap">
        <button type="button" :class="tooltipToggle ? 'question-btn on' : 'question-btn' " @click.prevent="clickTooltip(tooltipToggle)"></button>

        <span class="question-popup" v-if="tooltipToggle">
          <p class="question-txt">{{productDescription}}<template v-if="passgroupType === 'voucher'">(자동결제/부가세 포함)</template></p>
          <button type="button" class="btn-popup-close" @click="close()">
            <span class="a11y-hidden">닫기</span>
          </button>
        </span>
      </div>
    </span>
    <template v-if="passgroupType === 'package' || passgroupType === 'use_package'">
      <button class="ticket-pack-btn" @click.prevent="setPackagePopup()">
        <span>패키지영화 자세히 보기</span>
      </button>
    </template>
    </p>

    <template v-if="passgroupType === 'voucher'">
      <p class="ticket-description">{{products.screen_name}} {{products.quality_name}}</p>
    </template>

    <!-- 이용중인 이용권 -->
    <template v-if="isUse">
      <!-- pooq 이용권 -->
      <template v-if="passgroupType === 'use_pooq' || passgroupType === 'use_voucher'">
        <p class="ticket-using-people">동시 이용자 수 <span class="title-dot"></span> <i class="icon-dotted"></i> {{concurrency.concurrency_count}}회선</p>
        <div class="ticket-left"><p class="ticket-name">{{products.screen_name}} {{products.quality_name}} </p></div>
      </template>
      <!-- pooq 이용권 -->

      <div v-if="passgroupType === 'use_one'" class="ticket-left">
        <p class="ticket-price-day">
          <span v-if="isUse" class="ticket-price" :style="'color: '+productgroups.color">{{useDay}}</span>
          <span v-else><span class="ticket-price" :style="'color: '+productgroups.color"> {{setNumberCommas(amount)}}원</span>/{{useDay}}</span>
        </p>
      </div>
      <div v-if="passgroupType === 'use_package'" class="ticket-left">
        <p class="ticket-price-day">
          <span v-if="isUse" class="ticket-price" :style="'color: '+productgroups.color">{{useDay}}</span>
        </p>
      </div>
      <!--<div v-else class="ticket-right">-->
        <!--<p class="ticket-price-day">-->
          <!--<span class="ticket-price" :style="'color: '+productgroups.color"> {{setNumberCommas(amount)}}원</span>/{{useDay}}-->
        <!--</p>-->
      <!--</div>-->
    </template>

    <!-- 구매가능 이용권 -->
    <template v-else>
      <!-- pooq 이용권 -->
      <!--<template v-if="passgroupType === 'voucher'">-->
      <!--<p class="ticket-using-people">동시 이용자 수 <span class="title-dot"></span> {{concurrency.concurrency_count}}회선</p>-->
      <!--</template>-->
      <!-- pooq 이용권 -->

      <div class="ticket-price-wrap">
        <div class="ticket-left">
          <!-- 추천 이용권 -->
          <template v-if="passgroupType === 'one'">
            <p class="ticket-price-day">
              <!--<span v-if="concurrency.displayamount" class="ticket-discount">{{setNumberCommas(concurrency.displayamount)}}원</span>-->
              <span class="ticket-price">{{setNumberCommas(amount)}}원</span><span>&nbsp;/&nbsp;</span><span class="use-day">{{useDay}}</span>
            </p>
          </template>
          <template v-else>
            <p class="ticket-price-day">
              <!--<span v-if="concurrency.displayamount" class="ticket-discount">{{setNumberCommas(concurrency.displayamount)}}원</span>-->
              <span class="ticket-price">{{setNumberCommas(amount)}}원</span><span>&nbsp;/&nbsp;</span><span class="use-day">{{useDay}}</span>
            </p>
          </template>
        </div>

        <div class="ticket-link" :style="setStyle('color')">
          <!--<span v-if="passgroupType !== 'one'" class="ticket-price">-->
            <!--<span v-if="concurrency.displayamount" class="ticket-discount">{{setNumberCommas(concurrency.displayamount)}}원</span>-->
            <!--{{setNumberCommas(amount)}}원-->
          <!--</span>-->
          <a href="#" @click.prevent="clickPurchase()" class="ticket-btn">구매</a>
        </div>
      </div>
    </template>
    <!-- 구매가능 이용권 -->

  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
// import NextButtonGrey from '@/assets/svg/common/ic-next-s-g.svg'
import { get } from 'lodash'
import { URL_ORIGIN } from '@/common/constant'
export default {
  props: {
    productgroups: {
      type: Object,
      required: true
    },
    passgroupType: {
      type: String,
      required: true
    },
    contentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isUse: false, //  이용중인 이용권 여부
      tooltipToggle: false,
      products: undefined,
      concurrency: undefined,
      productid: '',
      amount: '',
      useDay: '',
      productUse: 'n' // 상품 구매 여부
    }
  },
  components: {
    // NextButtonGrey
  },
  computed: {
    productDescription () {
      return get(this.productgroups, 'description', '').trim() || get(this.concurrency, 'description', '')
    }
  },
  methods: {
    setListClass () {
      if (this.isUse || this.passgroupType === 'use_voucher') {
        return 'ticket-list ticket-using'
      } else if (this.passgroupType === 'one' || this.passgroupType === 'package') {
        return 'ticket-list'
      } else if (this.passgroupType === 'voucher') {
        return 'ticket-list ticket-green'
      }
      return 'ticket-list'
    },
    borderStyle () {
      return 'border: solid 1px #1351f9;'
    },
    // 천단위 콤마 적용
    setNumberCommas (price) {
      return utils.common.setNumberCommas(price)
    },
    // 구매하기 버튼
    clickPurchase () {
//      let url = window.location.origin + '/callback.html?action=ClosePopupAndReload'
      let url = URL_ORIGIN + '/callback.html?action=ClosePopupAndReload'
      utils.common.showBillingPopup({ productId: this.productid, productType: 'all', returnUrl: url, contentType: 'movie', contentId: this.contentId })
    },
    setStyle (type) {
      let returnStyle = type + ': #1351f9'
      if (this.productUse === 'y') {
        returnStyle = type + ': ' + this.productgroups.color
      }
      return returnStyle
    },
    setPackagePopup () {
      if (this.productid !== '') {
        EventBus.$emit('setPackagePopupOpen', this.productid, this.productgroups.productgroup_name)
      }
    },
    clickTooltip (toggle) {
      this.tooltipToggle = !toggle
    },
    close () {
      this.tooltipToggle = false
    }
  },
  created () {
    this.products = this.productgroups.products[0]
    this.concurrency = this.products.concurrency[0]

    this.productid = this.concurrency.productid
    this.amount = this.concurrency.amount
    this.useDay = this.concurrency.use_day
    this.productUse = this.concurrency.product_use

    if (this.passgroupType.indexOf('use') > -1) {
      this.isUse = true
    }
  }
}
</script>

<style scoped>
  .ticket-gray {
    border: 1px solid #777;
  }
  .ticket-list {
    position: relative;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 4px;
    background-color: #252525;
  }
  .tag-using{
    display: block;
    width: 45px;
    padding: 2px 0;
    margin-bottom: 5px;
    text-align: center;
    font-size: 10px;
    line-height: 14px;
    color: #3887ff;
    border: 1px solid #3887ff;
  }
  .ticket-tit{
    font-size: 13px;
    color: #23212a;
  }
  .ticket-btit, .ticket-tit {
    letter-spacing: -.2px;
    margin-bottom: 5px;
  }
  .ticket-hd{
    position: relative;
    margin: 0 -16px 16px;
    padding: 0 16px 16px;
    border-bottom: 1px #2f2f2f solid;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    text-align: left;
  }
  .ticket-hd-txt{
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }
  .ticket-using-people{
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
  }
  .ticket-price-wrap{
    position: relative;
  }
  .ticket-description + .ticket-price-wrap{
    margin-top: 8px;
  }
  .ticket-left,
  .ticket-link{
    display: inline-block;
    font-size: 0;
    vertical-align: middle;
  }
  .ticket-left{
    padding-right: 80px;
    word-break: break-all;
  }
  .ticket-link{
    position: absolute;
    top: 1px;
    right: 0;
  }
  .ticket-left .ticket-name{
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }
  .ticket-price-day {
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
  .ticket-price-day > span{
    vertical-align: middle;
  }
  .ticket-price {
    vertical-align: middle;
  }
  .ticket-btn {
    display: inline-block;
    width: 70px;
    height: 24px;
    border: 1px #1351f9 solid;
    border-radius: 12px;
    background-color: #1351f9;
    font-size: 12px;
    line-height: 22px;
    color: #fff;
    text-align: center;
  }
  .ticket-pack-btn{
    margin-top: 8px;
    color: #777;
    text-decoration: underline;
  }
  .ticket-pack-btn span,
  .ticket-pack-btn svg{
    vertical-align: middle;
  }
  .use-day{
    vertical-align: middle;
  }
  .next-icon{
    vertical-align: middle;
  }
  .ticket-green .ticket-discount {
    opacity: .5;
    display: inline-block;
    margin-right: 5px;
    text-decoration: line-through;
    /*color: #39b766;*/
    vertical-align: middle;
  }
  .ticket-green .ticket-price {
    font-weight: 700;
    vertical-align: middle;
    /*color: #39b766 !important;*/
  }
  .ticket-green .ticket-btn {
    /*background-color: #39b766 !important;*/
  }
  .ticket-description{
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }
</style>
